<template>
  <div>
    <Spinner v-if="isLoading" />

    <div class="notification is-info" v-if="hasNoGamecamConfigs">No gamecam configs found.</div>

    <div class="notification is-danger" v-if="loadError">{{ loadError }}</div>

    <HuntAreaGamecamConfigsList
      :huntArea="huntArea"
      :gamecamConfigs="gamecamConfigs"
      :usersCacheStorePath="usersCacheStorePath"
      v-if="gamecamConfigsLoaded"/>
  </div>
</template>

<script>
import Spinner from "@/components/utils/Spinner";
import HuntAreaGamecamConfigsList from "./HuntAreaGamecamConfigsList";

import {
  GET_HUNT_AREA,
  LOAD_GAMECAM_CONFIGS,
  GET_GAMECAM_CONFIGS,
  IS_LOADING_GAMECAM_CONFIGS,
  GET_GAMECAM_CONFIGS_LOAD_ERROR,
  HAS_EMPTY_GAMECAM_CONFIGS_LOAD_RESULT
} from "./huntAreaStore";

export default {
  name: "HuntAreaGamecamConfigsTab",

  components: {
    Spinner,
    HuntAreaGamecamConfigsList
  },

  props: {
    huntAreaStorePath: {
      type: String,
      required: true
    },

    usersCacheStorePath: {
      type: String,
      required: true
    }
  },

  mounted() {
    const loadGamecamConfigsAction = `${this.huntAreaStorePath}/${LOAD_GAMECAM_CONFIGS}`;
    this.$store.dispatch(loadGamecamConfigsAction);
  },

  computed: {
    gamecamConfigsLoaded() {
      return this.huntArea != null && this.gamecamConfigs !== null;
    },

    huntArea() {
      const getHuntArea = `${this.huntAreaStorePath}/${GET_HUNT_AREA}`;
      return this.$store.getters[getHuntArea];
    },

    gamecamConfigs() {
      const getGamecamConfigs = `${this.huntAreaStorePath}/${GET_GAMECAM_CONFIGS}`;
      return this.$store.getters[getGamecamConfigs];
    },

    isLoading() {
      const isLoadingGamecamConfigs = `${this.huntAreaStorePath}/${IS_LOADING_GAMECAM_CONFIGS}`;
      return this.$store.getters[isLoadingGamecamConfigs];
    },

    hasNoGamecamConfigs() {
      const hasEmptyGamecamConfigsLoadResult = `${this.huntAreaStorePath}/${HAS_EMPTY_GAMECAM_CONFIGS_LOAD_RESULT}`;
      return this.$store.getters[hasEmptyGamecamConfigsLoadResult];
    },

    loadError() {
      const getGamecamConfigsLoadError = `${this.huntAreaStorePath}/${GET_GAMECAM_CONFIGS_LOAD_ERROR}`;
      return this.$store.getters[getGamecamConfigsLoadError];
    }
  }
}
</script>

<style>

</style>
